<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    :mode="mode"
    :name="String(_uid)"
    :rules="rules"
  >
    <v-text-field
      v-model="innerValue"
      :type="type"
      :prepend-icon="icon"
      :autofocus="autofocus"
      :class="`${customClass} ${requiredClassByRules()}`"
      :error-messages="errors"
      :hide-details="hideMessages"
      :suffix="suffix"
      v-bind="$attrs"
      :loading="loading"
      :data-cy-validation-result="errors.length ? rulesToString() : false"
      v-on="$listeners"
    ></v-text-field>
  </ValidationProvider>
</template>

<script>
import { validationMixin } from '../mixins/validation'

export default {
  mixins: [validationMixin],
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
    customClass: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'aggressive',
    },
    vid: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    hideMessages: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
